import React, { useState, useEffect } from "react";
import {
  Paper,
  Grid,
  Typography,
  Button,
  MenuItem,
  Select,
  Avatar,
  Box,
  Drawer,
  IconButton,
  useMediaQuery,
  CircularProgress, Card,
  CardContent,Divider,
  TextField
} from "@mui/material";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { styled } from "@mui/material/styles";
import { useParams } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useAuth } from "../../../AuthProvider";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

// Styled components
const StyledCalendar = styled(Calendar)`
  width: 100% !important;
  max-width: 1200px;
  border: none;
  margin: 0 auto; /* Center horizontally */
  background-color: #81b9bb;
  

  .react-calendar__tile {
    padding: 25px;
    text-align: center;
    background-color: white; /* Background color */
    color: #000000; /* Text color */
    border: 1px solid white; /* Border color and thickness */
    border-radius: 0.5px; /* Round the corners */
    font-weight: bold;
    font-size: 16px;
    pointer-events: auto;
  }

  .react-calendar__navigation {
    display: none;
  }

  .react-calendar_month-viewdays_day--weekend {
    background-color: #b3afaf;
  }

  .react-calendar__tile:disabled {
    background-color: #f0f0f0;
    color: #b0b0b0;
  }

  .react-calendar__tile--now {
    background-color: white;
    color: green;
    border: 2px solid #d4a8f4;
  }

  .react-calendar__tile--active {
    background-color: #e0e0e0;
    color: #000000;
  }

  .highlighted-present {
    background-color: #5bb659 !important;
    color: white !important;
  }
  
    .highlighted-holiday {
    background-color: #CA96D8 !important;
    color: white !important;
  }

  .highlighted-halfDay {
    background-color: #7b81e1 !important;
    color: white !important;
  }

  .highlighted-sunday {
  background-color: #A99E9E; /* Set the background color to black */
  color: white; /* Set the text color to white for contrast */
}

  .highlighted-absent {
    background-color: #F55A5C !important;
    color: white !important;
  }

  .highlighted-leave {
    background-color: #fae79b !important;
    color: white !important;
  }
`;

const Container = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  marginTop: theme.spacing(9),
  marginLeft: theme.spacing(3),
  marginRight: theme.spacing(3),
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.common.white,
}));

const StatusCard = styled(Box)(({ theme, status }) => ({
  backgroundColor:
    status === "Present"
      ? "#5bb659"
      : status === "Absent"
      ? "#F55A5C"
      : status === "halfDay"
      ? "#7B81E1"
      : status === "week off"
      ? "#A99E9E"
      : status === "latePunchIn"
      ? "#f5b14bff" // Orange background
      : "#eeeeee",
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  textAlign: "center",
  borderLeft: `4px solid ${
    status === "Present"
      ? "#046b14"
      : status === "Absent"
      ? "#e31735"
      : status === "halfDay"
      ? "#1620CC"
      : status === "week off"
      ? "#615959"
      : status === "latePunchIn"
      ? "#EF6C00" // Darker orange border
      : "#9e9e9e"
  }`,
}));


const baseUrl = process.env.REACT_APP_API_BASE_URL;

const EmployeeAttendanceDetails = () => {
  const { empId, employeeId, } = useParams();
  // console.log("Employee IDd:", empId);
  const [calendarDate, setCalendarDate] = useState(new Date());
  const [attendanceDates, setAttendanceDates] = useState([]);
  const [halfDayAttendanceDates, setHalfDayAttendanceDates] = useState([]);
  const [leaveDates, setLeaveDates] = useState([]);
  const [employeesData, setEmployeesData] = useState({});
  const [presentCount, setPresentCount] = useState(0);
  const [halfDayCount, setHalfDayCount] = useState(0);
  const [absentDatesCount, setAbsentDatesCount] = useState(0);
  const [weekOffCount, setWeekOffCount] = useState(0);
  const [loadingButton, setLoadingButton] = useState(""); // State to track which button is loading
  const [loading, setLoading] = useState(true); // State for avatar loading
  const [holidays, setHolidays] = useState([])
  const [adminData, setAdminData] = useState([])
  const [isDrawerOpen, setIsDrawerOpen] = useState(false); // State for Drawer (Side Modal)
  const [selectedDate, setSelectedDate] = useState(null);
  const [halfDayAttendanceRecords, setHalfDayAttendanceRecords] = useState([]);
  const [date, setDate] = useState(new Date());
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  // present need to update to absent
  const [newEmployeeId, setNewEmployeeId] = useState(null);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const [dateId, setDateId] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState({});
  const [isEditingCheckIn, setIsEditingCheckIn] = useState(false); // State to toggle check-in input field
  const [isEditingCheckOut, setIsEditingCheckOut] = useState(false); // State to toggle check-out input field
  const [checkIn, setCheckIn] = useState(selectedEmployee?.checkIn || ''); // Initial check-in time
  const [checkOut, setCheckOut] = useState(selectedEmployee?.checkOut || '');
  const {oId,organizationId,pId}=useAuth()
  // const [holidays, setHolidays] = useState([])

  const onDateChange = (date) => {
   
    setSelectedDate(date);
    fetchAllAttendance(date); // Fetch attendance for the selected date
    setIsDrawerOpen(true);
  };

  const handleMonthChange = (event) => {
    const newMonth = event.target.value;
    const newDate = new Date(date.getFullYear(), newMonth, 1);
    setDate(newDate);
    setSelectedMonth(newMonth);
  };



  useEffect(() => {
    fetchEmployees();
    fetchMonthlyAttendance();
    fetchHolidayDates();
    fetchPresentCount(selectedYear, selectedMonth);
    fetchHalfDayCount(selectedYear, selectedMonth);
    fetchNumberOfSundays(selectedYear, selectedMonth);
  }, [empId, selectedYear, selectedMonth]);

  // Image loading code
  // useEffect(() => {
  //   if (employeesData.length > 0) {
  //     const image = new Image();
  //     image.src = employeesData[0].profilePic;
  //     image.onload = () => {
  //       setLoading(false);
  //     };
  //   }
  // }, [employeesData]);
  const fetchHolidayDates = async () => {
    try {
      const response = await fetch(`${baseUrl}/api/holiday/all/${oId}/${pId}`);
      if (!response.ok) {
        throw new Error("Failed to fetch holidays");
      }
      const data = await response.json();
  
      // Map holidays to include both date and name
      const holidayList = data.map(holiday => ({
        date: holiday.holidayDate,  // e.g., '2024-09-07'
        name: holiday.holidayName   // e.g., 'Labor Day'
      }));
  
      setHolidays(holidayList); // Store the holiday list as an array of objects
      console.log('Holidays:', data); // For debugging purposes
  
    } catch (error) {
      console.error("Error fetching holidays:", error);
    } 
  };

  const getTodayDate = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const todayDate = getTodayDate();

  // const fetchAllAttendance = async (selectedDate) => {
  //   try {
  //     const selectedDateFormatted = selectedDate.toLocaleDateString("en-CA")
     
  
  //     const response = await fetch(
  //       `http://192.168.1.24:8080/api/attendance/employee/${empId}/date/${selectedDateFormatted}`
  //     );
  //     const data = await response.json();
  
  //     // Log the raw response data
  //     console.log("Raw API response data:", data);
  
  //     // Only update if data exists, otherwise clear the card
  //     if (Object.keys(data).length > 0) {
  //       setSelectedEmployee({
  //         ...data,
  //         checkInPic: data.checkInPic ? `data:image/jpeg;base64,${data.checkInPic}` : null,
  //         checkOutPic: data.checkOutPic ? `data:image/jpeg;base64,${data.checkOutPic}` : null,
  //       });
  //     } else {
  //       // Clear the card if no data is returned
  //       setSelectedEmployee({});
  //     }
  //   } catch (error) {
  //     console.error("Failed to fetch attendance", error);
  //   }
  // };
  
  const fetchAllAttendance = async (selectedDate) => {
    try {
     
      const selectedDateFormatted = selectedDate.toLocaleDateString("en-CA");
  
      const response = await fetch(
        `${baseUrl}/api/attendance/employee/${employeeId}/date/${selectedDateFormatted}`
      );
      const data = await response.json();
      setDateId(data.id)
  
      // Log the raw response data
      console.log("Raw API response data:", data);

  
      if (data && Object.keys(data).length > 0) {
        setSelectedEmployee({
          ...data,
          checkInPic: data.checkInPic
            ? `data:image/jpeg;base64,${data.checkInPic}`
            : null,
          checkOutPic: data.checkOutPic
            ? `data:image/jpeg;base64,${data.checkOutPic}`
            : null,
        });
      } else {
        // Clear the card if no data is returned
        setSelectedEmployee(null); // Set to null when no data is available
      }
    } catch (error) {
      console.error("Failed to fetch attendance", error);
      setSelectedEmployee(null); // Clear the card on error
    }
  };
  
  useEffect(() => {
    if (selectedDate) {
      fetchAllAttendance(); // Fetch attendance when selectedDate changes
    }
  }, [selectedDate]);






  //for punch in location
  const truncateString = (str, num) => {
    if (typeof str !== "string") {
      return "Punch In Location Not Found";
    }
    if (str.length <= num) {
      return str;
    }
    return str.slice(0, num) + "...";
  };

  //for punch out location
  const truncateStringOUT = (str, num) => {
    if (typeof str !== "string") {
      return "Punch Out Location Not Found";
    }
    if (str.length <= num) {
      return str;
    }
    return str.slice(0, num) + "...";
  };
//Fetch Holiday Dates in calendar
// const fetchHolidayDates = async () => {
//   try {
//     const response = await fetch("http://192.168.1.24:8080/api/holiday/all"); // Replace with your backend API URL
//     if (!response.ok) {
//       throw new Error("Failed to fetch holidays");
//     }
//     const data = await response.json();
    
//     // Extract holidayDate from each holiday object using map 
//     const holidayDates = data.map(holiday => holiday.holidayDate); // Adjust according to your response structure
//     console.log("Holiday Dates:", holidayDates); // Log the extracted dates or do something with them
//     setHolidays(holidayDates)
//     console.log('holidays list :', holidays)


//   } catch (error) {
//     console.error("Error fetching holidays:", error);
//   } 
// };

//fetch holidays dates new code
// const fetchHolidayDates = async () => {
//   try {
//     const response = await fetch(`${baseUrl}/api/holiday/all/${oId}`);
//     if (!response.ok) {
//       throw new Error("Failed to fetch holidays");
//     }
//     const data = await response.json();

//     // Map holidays to include both date and name
//     const holidayList = data.map(holiday => ({
//       date: holiday.holidayDate,  // e.g., '2024-09-07'
//       name: holiday.holidayName   // e.g., 'Labor Day'
//     }));

//     setHolidays(holidayList); // Store the holiday list as an array of objects
//     console.log('Holidays:', data); // For debugging purposes

//   } catch (error) {
//     console.error("Error fetching holidays:", error);
//   } 
// };

  // Fetch Employee Data
  const fetchEmployees = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${baseUrl}/api/employee/getById/${employeeId}`
      );
      const data = await response.json();

      // const employeeWithImage = {
      //   ...data,
      //   profilePic: `data:image/jpeg;base64,${data.profilePic}`,
      // };

      setEmployeesData(data);
      setNewEmployeeId(data.employeeId);
    } catch (error) {
      console.error("Error fetching employees:", error);
    }finally{
      setLoading(false);
    }
  };

  // Fetch Attendance Counts
  const fetchAttendanceCounts = async () => {
    try {
      await fetchPresentCount();
      await fetchHalfAttendance(selectedMonth, selectedYear);
      await fetchHalfDayCount();
      // await fetchHolidayDates()
    } catch (error) {
      console.error("Error fetching attendance counts:", error);
    }
  };

  useEffect(() => {
 
      fetchAttendanceCounts(); // Fetch attendance when selectedDate changes
 
  }, []);

  //Present Count
  const fetchPresentCount = async () => {
    try {
      const response = await fetch(
        `${baseUrl}/api/attendance/count-by-month-year/${empId}/${selectedYear}/${
          selectedMonth + 1
        }`
      );
      const data = await response.json();
      setPresentCount(data);
    } catch (error) {
      console.error("Error fetching present count:", error);
    }
  };

  //halfDay Count
  const fetchHalfDayCount = async () => {
    try {
      const response = await fetch(
        `${baseUrl}/api/attendance/halfDayCount/${empId}/${selectedYear}/${
          selectedMonth + 1
        }`
      );
      const data = await response.json();
      setHalfDayCount(data);
    } catch (error) {
      console.error("Error fetching present count:", error);
    }
  };

  // GET Method- for monthly Attendance
  const fetchMonthlyAttendance = async () => {
    try {
      const response = await fetch(
        `${baseUrl}/api/attendance/students/monthly/${employeeId}/${selectedYear}/${
          selectedMonth + 1
        }`
      );
      const data = await response.json();

      // Convert each API date to a local date string in YYYY-MM-DD format
      const presentDates = data.map((record) => {
        const dateObj = new Date(record.date);
        return dateObj.toLocaleDateString("en-CA");
      });

      fetchHalfAttendance();
      setAttendanceDates(presentDates);
      setAdminData(data)
    } catch (error) {
      console.error("Error fetching monthly attendance:", error);
    }
  };

  // GET Method- for monthly Attendance
  const fetchHalfAttendance = async () => {
    try {
      const response = await fetch(
        `${baseUrl}/api/attendance/employee/HalfDay/monthly/${empId}/${selectedYear}/${
          selectedMonth + 1
        }`
      );
      const data = await response.json();

      // Convert each API date to a local date string in YYYY-MM-DD format
      const presentDates = data.map((record) => {
        const dateObj = new Date(record.date);
        return dateObj.toLocaleDateString("en-CA");
      });

      console.log("i am HalfdayAttendance: " + presentDates);

      setHalfDayAttendanceDates(presentDates);
    } catch (error) {
      console.error("Error fetching monthly attendance:", error);
    }
  };

  // GET method for "Leave Requests"
  // const fetchLeaveRequests = async () => {
  //   try {
  //     const response = await fetch(
  //       `${baseUrl}/api/leave/leaveRequestsBy/${employeeId}/${selectedYear}/${
  //         selectedMonth + 1
  //       }`
  //     );
  //     const data = await response.json();

  //     // Extract all leave dates between startDate and endDate
  //     const dates = [];
  //     data.forEach((leave) => {
  //       const [startYear, startMonth, startDay] = leave.startDate;
  //       const [endYear, endMonth, endDay] = leave.endDate;

  //       const startDate = new Date(startYear, startMonth - 1, startDay);
  //       const endDate = new Date(endYear, endMonth - 1, endDay);

  //       let currentDate = startDate;
  //       while (currentDate <= endDate) {
  //         dates.push(currentDate.toLocaleDateString("en-CA"));
  //         currentDate.setDate(currentDate.getDate() + 1);
  //       }
  //     });

  //     setLeaveDates(dates);
  //   } catch (error) {
  //     console.error("Error fetching leave requests:", error);
  //   }
  // };
const fetchLeaveRequests = async () => {
  try {
    const response = await fetch(
      `${baseUrl}/api/leave/leaveRequestsBy/${employeeId}/${selectedYear}/${selectedMonth + 1}`
    );
    const data = await response.json();

    const dates = [];

    data.forEach((leave) => {
      const startDate = new Date(leave.startDate); // from "2025-07-10"
      const endDate = new Date(leave.endDate);     // from "2025-07-12"

      let currentDate = new Date(startDate); // Copy to avoid mutation
      while (currentDate <= endDate) {
        const formatted = currentDate.toLocaleDateString("en-CA"); // 'YYYY-MM-DD'
        dates.push(formatted);
        currentDate.setDate(currentDate.getDate() + 1);
      }
    });

    setLeaveDates(dates);
  } catch (error) {
    console.error("Error fetching leave requests:", error);
  }
};


    useEffect(() => {

    fetchLeaveRequests();

}, [employeeId,selectedYear,selectedMonth]);



  //side model buttons code
  const handleAttendanceChange = async (status) => {
    if (selectedDate) {
      const formattedDate = selectedDate.toLocaleDateString("en-CA"); // Format date as 'YYYY-MM-DD'
      setLoadingButton(status); // Start loader for the specific button
  
      if (status === "Absent") {
        console.log("Updating status to absent");
  
        const url = `${baseUrl}/api/attendance/absent/${newEmployeeId}/${selectedYear}/${
          selectedMonth + 1
        }/${selectedDate.getDate()}`;
  
        try {
          const response = await fetch(url, {
            method: "DELETE",
          });
  
          if (response.ok) {
            console.log("Attendance record deleted successfully");
            toast.success('Attendance marked as Absent!', {
              position: 'top-right',
              autoClose: 1000, // Close after 1 second
            });
            fetchAttendanceCounts();
            fetchMonthlyAttendance();
            setSelectedEmployee({});
            fetchAllAttendance();
            setIsDrawerOpen(false);
          } else {
            // console.error("Failed to delete attendance record");
            toast.error('Failed to mark attendance as Absent.', {
              position: 'top-right',
              autoClose: 1000,
            });
          }
        } catch (error) {
          // console.error("Error while deleting attendance record:", error);
          toast.error('Error while updating attendance!', {
            position: 'top-right',
            autoClose: 1000,
          });
        } finally {
          setLoadingButton(""); // Stop loader
        }
      } else if (status === "Present") {
        console.log("Marking attendance as present");
  
        const url = `${baseUrl}/api/attendance/present/${newEmployeeId}/${selectedYear}/${
          selectedMonth + 1
        }/${selectedDate.getDate()}/${oId}`;
  
        const requestBody = {
          date: formattedDate,
          employeeId: newEmployeeId,
        };
  
        try {
          const response = await fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
          });
  
          if (response.ok) {
            console.log("Attendance marked as present");
            toast.success('Attendance marked as Present!', {
              position: 'top-right',
              autoClose: 1000, // Close after 1 second
            });
  
            // Refresh attendance data after marking as present
            await fetchAttendanceCounts();
            await fetchMonthlyAttendance(); // Ensure this is called to refresh calendar
            fetchAllAttendance();
            setIsDrawerOpen(false);
          } else {
            // console.error("Failed to mark attendance as present");
            toast.error('Failed to mark attendance as Present.', {
              position: 'top-right',
              autoClose: 1000,
            });
          }
        } catch (error) {
          // console.error("Error while marking attendance as present:", error);
          toast.error('Error while marking attendance as present.', {
            position: 'top-right',
            autoClose: 1000,
          });
        } finally {
          setLoadingButton(""); // Stop loader
        }
      } else if (status === "halfDay") {
        console.log("Marking attendance as half-day");
  
        const url = `${baseUrl}/api/attendance/halfDay/${newEmployeeId}/${selectedYear}/${
          selectedMonth + 1
        }/${selectedDate.getDate()}`;
  
        const requestBody = {
          date: formattedDate,
          employeeId: newEmployeeId,
        };
  
        try {
          const response = await fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
          });
  
          if (response.ok) {
            const data = await response.json();
            if (data.numberOfHours < 4) {
              // Store the date in the correct format to match the tileClassName format
              const dateKey = selectedDate.toLocaleDateString("en-CA");
              setHalfDayAttendanceRecords((prev) => [...prev, dateKey]); // Add to half-day records
              console.log("Attendance marked as half-day:", response);
            }
  
            // Refresh attendance data after marking as half-day
            await fetchAttendanceCounts();
            await fetchMonthlyAttendance(); // Ensure this is called to refresh calendar
            fetchAllAttendance();
           
            toast.success('Attendance marked as Half-Day!', {
              position: 'top-right',
              autoClose: 1000,
            });
            setIsDrawerOpen(false);
          } else {
            // console.error("Failed to mark attendance as half-day");
            toast.error('Failed to mark attendance as Half-Day.', {
              position: 'top-right',
              autoClose: 1000,
            });
          }
        } catch (error) {
          // console.error("Error while marking attendance as half-day:", error);
          toast.error('Error while marking attendance as Half-Day.', {
            position: 'top-right',
            autoClose: 1000,
          });
        } finally {
          setLoadingButton(""); // Stop loader
        }
      } else if (status === "fullDay") {
        console.log("Marking attendance as full-day");
  
        const url = `${baseUrl}/api/attendance/fullDay/${newEmployeeId}/${selectedYear}/${
          selectedMonth + 1
        }/${selectedDate.getDate()}`;
  
        const requestBody = {
          date: formattedDate,
          employeeId: newEmployeeId,
        };
  
        try {
          const response = await fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
          });
  
          if (response.ok) {
            const data = await response.json();
            if (data.numberOfHours < 4) {
              // Store the date in the correct format to match the tileClassName format
              const dateKey = selectedDate.toLocaleDateString("en-CA");
              setHalfDayAttendanceRecords((prev) => [...prev, dateKey]); // Add to half-day records
              console.log("Attendance marked as full-day:", response);
            }
  
            // Refresh attendance data after marking as full-day
            await fetchAttendanceCounts();
            await fetchMonthlyAttendance(); // Ensure this is called to refresh calendar
            fetchAllAttendance();
            
            toast.success('Attendance marked as Full-Day!', {
              position: 'top-right',
              autoClose: 1000,
            });
            setIsDrawerOpen(false);
          } else {
            // console.error("Failed to mark attendance as full-day");
            toast.error('Failed to mark attendance as Full-Day.', {
              position: 'top-right',
              autoClose: 1000,
            });
          }
        } catch (error) {
          // console.error("Error while marking attendance as full-day:", error);
          toast.error('Error while marking attendance as Full-Day.', {
            position: 'top-right',
            autoClose: 1000,
          });
        } finally {
          setLoadingButton(""); // Stop loader
        }
      }
    }
  };

  const fetchNumberOfSundays = async () => {
    try {
      const response = await fetch(
        `${baseUrl}/api/attendance/count-week-off/${selectedYear}/${
          selectedMonth + 1
        }`
      );

      if (!response.ok) {
        throw new Error(
          `Failed to fetch number of Sundays: ${response.statusText}`
        );
      }

      const sundayCount = await response.json(); // Assuming the response is a simple integer
      setWeekOffCount(sundayCount);
    } catch (error) {
      console.error("Error fetching number of Sundays:", error);
    }
  };

  // Handles year and month selection
  const handleYearMonthChange = (event) => {
    const [year, month] = event.target.value.split("-");
    setSelectedYear(parseInt(year));
    setSelectedMonth(parseInt(month) - 1); // Set month to zero-based index
  };

  


  useEffect(() => {
    const absentCount = calculateAbsentDatesCount();
    setAbsentDatesCount(absentCount);
  }, [attendanceDates, selectedYear, selectedMonth]);

  // Function to calculate absent dates count
  const calculateAbsentDatesCount = () => {
    let count = 0;
    const currentMonthDates = new Date(
      selectedYear,
      selectedMonth + 1,
      0
    ).getDate(); // Total days in selected month

    for (let day = 1; day <= currentMonthDates; day++) {
      const date = new Date(selectedYear, selectedMonth, day);
      const dateStr = date.toLocaleDateString("en-CA");

      // Only count past dates that are not present in attendanceDates
      if (date <= new Date() && !attendanceDates.includes(dateStr)) {
        count++;
      }
    }
    return count;
  };

 

  // const tileClassName = ({ date, view }) => {
  //   if (view === "month") {
  //     const dateStr = date.toLocaleDateString("en-CA"); // Format date to 'YYYY-MM-DD'
  
  //     // Check if the date is a holiday
  //     const holiday = holidays.find(h => h.date === dateStr);
  
  //     // Check if the date is a Sunday
  //     if (date.getDay() === 0) {
  //       return "highlighted-sunday"; // Add a class for Sundays
  //     }
  
  //     // Highlight holidays and add a custom class
  //     // if (holiday) {
  //     //   return "highlighted-holiday"; // Add a class for holidays
  //     // }

  //    // Highlight holidays
  //   if (holiday) {
  //     // If the holiday date is also marked as present, show it as present
  //     if (attendanceDates.includes(dateStr)) {
  //       return "highlighted-present"; // Green for present dates
  //     }
  //     if (halfDayAttendanceDates.includes(dateStr)) {
  //       return "highlighted-halfDay"; // Pink for half-day attendance
  //     }
  //     return "highlighted-holiday"; // Highlight as holiday if not present
  //   }
  
  //     // Other conditions (attendance, leave, etc.)
  //     if (attendanceDates.includes(dateStr)) {
  //       return "highlighted-present"; // Green for present dates
  //     }
  
  //     if (leaveDates.includes(dateStr)) {
  //       return "highlighted-leave"; // Yellow for leave dates
  //     }
  
  //     if (halfDayAttendanceDates.includes(dateStr)) {
  //       return "highlighted-halfDay"; // Pink for half-day attendance
  //     }
  
  //     if (date <= new Date() && !attendanceDates.includes(dateStr)) {
  //       return "highlighted-absent"; // Red for absent past dates
  //     }
  //   }
  
  //   return null; // No special class if no condition matches
  // };
  const tileClassName = ({ date, view }) => {
    if (view === "month") {
      const dateStr = date.toLocaleDateString("en-CA"); // Format date to 'YYYY-MM-DD'
  
      // Check if the date is a holiday
      const holiday = holidays.find(h => h.date === dateStr);
  
      // Check if the date is a Sunday
      if (date.getDay() === 0) {
        return "highlighted-sunday"; // Add a class for Sundays
      }
  
      // Highlight holidays and add a custom class
      // if (holiday) {
      //   return "highlighted-holiday"; // Add a class for holidays
      // }

     // Highlight holidays
    if (holiday) {
      // If the holiday date is also marked as present, show it as present
      if (attendanceDates.includes(dateStr)) {
        return "highlighted-present"; // Green for present dates
      }
      if (halfDayAttendanceDates.includes(dateStr)) {
        return "highlighted-halfDay"; // Pink for half-day attendance
      }
      return "highlighted-holiday"; // Highlight as holiday if not present
    }
  
      // Other conditions (attendance, leave, etc.)
      if (attendanceDates.includes(dateStr)) {
        return "highlighted-present"; // Green for present dates
      }
  
      if (leaveDates.includes(dateStr)) {
        return "highlighted-leave"; // Yellow for leave dates
      }
  
      if (halfDayAttendanceDates.includes(dateStr)) {
        return "highlighted-halfDay"; // Pink for half-day attendance
      }
  
      if (date <= new Date() && !attendanceDates.includes(dateStr)) {
        return "highlighted-absent"; // Red for absent past dates
      }
    }
  
    return null; // No special class if no condition matches
  };

  // const tileContent = ({ date, view }) => {
  //   if (view === "month") {
  //     const dateStr = date.toLocaleDateString("en-CA");
     
  
  //     // Check if the date is a holiday
  //     const holiday = holidays.find(h => h.date === dateStr);
    
  //     if (holiday) {
  //       return (
  //         <div style={{ color: '#6d6873', fontSize: '12px', textAlign: 'center', position: "relative", bottom: "-5px" }}>
  //           {holiday.name}
  //         </div>
  //       );
  //     }
    
      
  //     // Filter attendanceDates for "Admin" status
  //     const adminEntries = adminData.filter(a => a.status === "Admin");
      
    
  //     // Find the entry with the matching dateStr
  //     const adminEntry = adminEntries.find(a => a.date === dateStr);
      
    
  //     // If there's an entry with the "Admin" status for this date, show "Admin Punched"
  //     if (adminEntry) {
  //       return (
  //         <div style={{ color: 'white', fontSize: '12px', textAlign: 'center', position: "relative", bottom: "-5px", fontWeight: 'bold' }}>
  //           Admin Punched
  //         </div>
  //       );
  //     }
  //   }
  
  //   return null;
  // };
  


  // Function to disable future dates
  
  const tileContent = ({ date, view }) => {
    if (view === "month") {
        const dateStr = date.toLocaleDateString("en-CA");

        // Check if the date is a holiday
        const holiday = holidays.find(h => h.date === dateStr);

        if (holiday) {
            return (
                <div style={{ color: 'white', fontSize: '12px', textAlign: 'center', position: "relative", bottom: "-5px" }}>
                    {holiday.name}
                </div>
            );
        }

        // Find the entry with the matching dateStr
        const entry = adminData.find(a => a.date === dateStr);

        // If there's an entry, check its status and display accordingly
        if (entry) {
          return (
              <div style={{
                  color: 'white',
                  fontSize: '12px',
                  textAlign: 'center',
                  position: "relative",
                  bottom: "-5px",
                  fontWeight: 'bold'
              }}>
                  {entry.status !== "Employee" && (entry.status === "Admin" ? "Admin" : "Biometric")}
              </div>
          );
      }
      
    }

    return null;
};

  
  
  const tileDisabled = ({ date }) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return date > today;
  };

  const handleGetClick = () => {
    // Set calendarDate to the first day of the selected month and year
    const newDate = new Date(selectedYear, selectedMonth, 1);
    setCalendarDate(newDate);
    // Fetch the updated data
    fetchAttendanceCounts();
    fetchMonthlyAttendance();
    fetchHolidayDates();
    fetchLeaveRequests();
    setAbsentDatesCount(calculateAbsentDatesCount()); // Calculate and set the absent count
  };

  
  

// Ensure the calendar updates when the selected year changes
useEffect(() => {
  setDate(new Date(selectedYear, selectedMonth, date.getDate()));
}, [selectedYear, selectedMonth]);



  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
    // setTimeout(() => {
    //   window.location.(); // Reloads the entire page
    // }, 100); // Delay to ensure the drawer closes first
  };


  // Function to handle API call for updating punch details
  const updatePunchDetails = async (updatedData) => {
    const url = `${baseUrl}/api/attendance/time/${dateId}?checkIn=${(checkIn || selectedEmployee?.checkIn)}&checkOut=${(checkOut || selectedEmployee?.checkOut)}`;
  
    const options = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    };
  
    try {
      const response = await fetch(url, options);
  
      if (response.ok) {
        const data = await response.json();
        console.log('Punch details updated successfully:', data);
  
        toast.success('Punch details updated successfully!', {
          position: 'top-right',
          autoClose: 1000, // Close after 1 second
        });
        setIsDrawerOpen(false)
  
        
        
        return data;
      } else {
        const errorData = await response.json();
        console.error('Error updating punch details:', errorData);
  
        toast.error('Error updating punch details', { position: 'top-right' });
  
        throw new Error('Error updating punch details');
      }
    } catch (error) {
      console.error('Error during API call:', error);
  
      toast.error('Error during API call', { position: 'top-right' });
  
      throw new Error('Error during API call');
    }
  };


  


  // Handle the update for Check-In time
// Handle the check-in update
const handleCheckInBlur = () => {
  const updatedData = {
    checkIn: checkIn || selectedEmployee.checkIn,
    checkOut: checkOut || selectedEmployee.checkOut, // Send both values
  };
  updatePunchDetails(updatedData);
  setIsEditingCheckIn(false);
};

// Handle the check-out update
const handleCheckOutBlur = () => {
  const updatedData = {
    checkIn: checkIn || selectedEmployee.checkIn,
    checkOut: checkOut || selectedEmployee.checkOut, // Send both values
  };
  updatePunchDetails(updatedData);
  setIsEditingCheckOut(false);
};
  const currentYear = new Date().getFullYear();
const years = [currentYear - 1, currentYear];


  const styles = {
    container: {
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap',
     
    },
    cardContainer: {
      display: 'flex',
      alignItems: 'center',
      marginRight: '20px',
      // marginTop: '50px',
    },
    card: {
      marginRight: '10px',
      marginTop:'2px',
      padding: '10px',
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '20px',
      height: '20px',
      borderRadius: '4px', // Rounded corners
    },
    presentCard: {
      backgroundColor: '#5bb659',
    },
    absentCard: {
      backgroundColor: '#F55A5C',
    },
    halfDayCard: {
      backgroundColor: '#7B81E1',
    },
    weekOffCard: {
      backgroundColor: '#A99E9E',
    },
    holidayCard: {
      backgroundColor: '#CA96D8',
    },
    leaveCard: {
      backgroundColor: '#fae79b',
      color: 'black', // Black text for better contrast on yellow background
    },
  };

  return (
    <Container>
      <Box
        display="flex"
        flexDirection={isMobile ? "column" : "row"} // Stack items vertically on mobile
        alignItems="center"
        justifyContent="space-between"
        mb={2}
       
      >
        {/* {loading ? (
          <Typography variant="body1" sx={{ fontSize: "30px" }} ml={5}>
            Loading.....
          </Typography>
        ) : (
          employeesData.length > 0 && (
            <Box display="flex" alignItems="center" mb={isMobile ? 2 : 0}>
             
              <ArrowBackIcon
                style={{
                  marginRight: isMobile ? 0 : 15, // Adjust margin on mobile and desktop
                  fontSize: "30px", // Adjust size as needed
                  cursor:'pointer'
                }}

                onClick={() => navigate(-1)}
              />

              <Avatar
                alt={`${employeesData[0].firstName} ${employeesData[0].lastName}`}
                src={employeesData[0].profilePic}
                style={{
                  marginLeft: isMobile ? 0 : 0, // Remove left margin on mobile
                  marginBottom: isMobile ? 10 : 0, // Add bottom margin on mobile
                  height: "65px",
                  width: "65px",
                }}
              />

              <Box
                ml={isMobile ? 0 : 2}
                mt={isMobile ? 1 : 0}
                textAlign={isMobile ? "center" : "left"}
              >
                <Typography
                  variant="h6"
                  sx={{ color: "black", fontWeight: "bold", fontSize: "20px" }}
                >
                  {employeesData[0].firstName} {employeesData[0].lastName}
                </Typography>
                <Typography
                  variant="h6"
                  sx={{ color: "black", fontSize: "15px" }}
                >
                  Employee Id: {employeesData[0].employeeId}
                </Typography>
              </Box>
            </Box>
          )
        )} */}


{loading ? (
  <Typography variant="body1" sx={{ fontSize: "20px" }} ml={5}>
    Loading...
  </Typography>
) : (
  employeesData && employeesData.firstName ? (  // Check if employeesData is not empty and has firstName
    <Box display="flex" alignItems="center" mb={isMobile ? 2 : 0}>
      {/* ArrowBackIcon */}
      <ArrowBackIcon
        style={{
          marginRight: isMobile ? 0 : 15,
          fontSize: "30px",
          cursor: 'pointer',
        }}
        onClick={() => navigate(-1)}
      />
     
      <Avatar
        alt={`${employeesData.firstName} ${employeesData.lastName}`}
        sx={{ bgcolor: "#3f51b5", color: "white" ,height:'48px',width:'48px'}}
      >
        {employeesData.firstName?.charAt(0).toUpperCase()}
        {employeesData.lastName?.charAt(0).toUpperCase()}
      </Avatar>

      <Box
        ml={isMobile ? 0 : 2}
        mt={isMobile ? 1 : 0}
        textAlign={isMobile ? "center" : "left"}
      >
        <Typography
          variant="h6"
          sx={{ color: "black", fontWeight: "bold", fontSize: "20px" }}
        >
          {employeesData.firstName} {employeesData.lastName}
        </Typography>
        <Typography
          variant="h6"
          sx={{ color: "black", fontSize: "15px" }}
        >
          Employee Id: {employeesData.employeeId}
        </Typography>
      </Box>
    </Box>
  ) : (
    <Typography variant="body1" sx={{ fontSize: "20px" }} ml={5}>
      No data available
    </Typography>
  )
)}
        <Box display="flex" flexDirection={isMobile ? "column" : "row"} gap={2}>
          <Select
            value={selectedMonth}
            // onChange={(e) => setSelectedMonth(e.target.value)}
            onChange={handleMonthChange}
            sx={{ width: isMobile ? "100%" : "120px" }}
          >
            {Array.from({ length: 12 }, (_, i) => (
              <MenuItem key={i} value={i}>
                {new Date(0, i).toLocaleString("default", { month: "long" })}
              </MenuItem>
            ))}
          </Select>
          <Select
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value)}
            sx={{ width: isMobile ? "100%" : "120px" }}
          >
            {years.map((year) => (
              <MenuItem key={year} value={year}>
                {year}
              </MenuItem>
            ))}
          </Select>
          {/* <Button
            variant="contained"
            color="primary"
            onClick={handleGetClick}
            sx={{ width: isMobile ? "100%" : "120px" }}
          >
            Get
          </Button> */}
        </Box>
      </Box>

 {/* 🔹 SECOND ROW — NOTE CARD */}
  {/* <Box
    sx={{
      mt: 1,
      p: 1.5,
      bgcolor: "#fff4e5",
      borderLeft: "4px solid #ff9800",
      borderRadius: "6px",
      display: "flex",
      alignItems: "flex-start",
      gap: 1.2,
      maxWidth: "100%",
      mb:1
    }}
  >
    <WarningAmberIcon sx={{ color: "#ff9800", mt: "2px" }} />

<Typography
  variant="body2"
  sx={{
    color: "#5d4636",
    fontSize: "0.9rem",
    lineHeight: 1.4,
    fontWeight: 500,
  }}
>
  {/* 1. After marking a student as <strong>Present</strong> or <strong>Absent</strong>, the attendance 
     will update within <strong>1 minute</strong>. Please wait for the update to complete and avoid 
     taking any further action during this time. <br /><br /> 
   In the monthly attendance calendar, <strong> today’s attendance </strong> will not be displayed immediately as<strong> Present </strong>.
   <br />
   <strong>Only previous days’ attendance will be shown as Present</strong>.
</Typography>



  </Box> */}

    <Grid container spacing={2} mb={5} mt={5}>
  <Grid item xs={12} md={2}>
    <StatusCard status="Present">
      <Typography variant="h6" sx={{ color: "white" }}>Present</Typography>
      <Typography variant="h4" sx={{ color: "white" }}>{presentCount.present || 0}</Typography>
    </StatusCard>
  </Grid>

  <Grid item xs={12} md={2}>
    <StatusCard status="Absent">
      <Typography variant="h6" sx={{ color: "white" }}>Absent</Typography>
      <Typography variant="h4" sx={{ color: "white" }}>{presentCount.absent || 0}</Typography>
    </StatusCard>
  </Grid>

  <Grid item xs={12} md={2}>
    <StatusCard
      onClick={() => navigate('/HolidayCalendar')}
      sx={{ cursor: "pointer", backgroundColor: "#CA96D8", borderLeft: "5px solid #A22FC1" }}
    >
      <Typography variant="h6" sx={{ color: "white" }}>Holidays Count</Typography>
      <Typography variant="h4" sx={{ color: "white" }}>{presentCount.holiday || 0}</Typography>
    </StatusCard>
  </Grid>

  <Grid item xs={12} md={2}>
    <StatusCard status="halfDay">
      <Typography variant="h6" sx={{ color: "white" }}>Half Days</Typography>
      <Typography variant="h4" sx={{ color: "white" }}>{halfDayCount || 0}</Typography>
    </StatusCard>
  </Grid>

  <Grid item xs={12} md={2}>
  <StatusCard status="latePunchIn">
    <Typography variant="h6" sx={{ color: "white" }}>Late Punch In</Typography>
    <Typography variant="h4" sx={{ color: "white" }}>{presentCount.latePunchIn || 0}</Typography>
  </StatusCard>
</Grid>

  <Grid item xs={12} md={2}>
    <StatusCard status="week off">
      <Typography variant="h6" sx={{ color: "white" }}>Week Offs</Typography>
      <Typography variant="h4" sx={{ color: "white" }}>{weekOffCount || 0}</Typography>
    </StatusCard>
  </Grid>
</Grid>

      <StyledCalendar
      //new code
      tileClassName={tileClassName}
      tileContent={tileContent}
      tileDisabled={tileDisabled}
      onClickDay={onDateChange}
      value={date}
      onChange={setDate}
      view="month"
      activeStartDate={new Date(selectedYear, selectedMonth, 1)} // Sync calendar view with selected year and month
      />
       
       <div style={styles.container}>
      <div style={styles.cardContainer}>
        <div style={{ ...styles.card, ...styles.presentCard }}></div>
        <h5>Present</h5>
      </div>
      <div style={styles.cardContainer}>
        <div style={{ ...styles.card, ...styles.absentCard }}></div>
        <h5>Absent</h5>
      </div>
      <div style={styles.cardContainer}>
        <div style={{ ...styles.card, ...styles.halfDayCard }}></div>
        <h5>Half Day</h5>
      </div>
      <div style={styles.cardContainer}>
        <div style={{ ...styles.card, ...styles.weekOffCard }}></div>
        <h5>Week Off</h5>
      </div>
      <div style={styles.cardContainer}>
        <div style={{ ...styles.card, ...styles.holidayCard }}></div>
        <h5>Holiday</h5>
      </div>
      <div style={styles.cardContainer}>
        <div style={{ ...styles.card, ...styles.leaveCard }}></div>
        <h5>Leave</h5>
      </div>
    </div>




      <Drawer
        anchor="right"
        open={isDrawerOpen}
        onClose={handleCloseDrawer} // Ensure this is correctly bound
      >
        <Box sx={{ width: 400, padding: 2 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h3" sx={{ fontWeight: "bold" }}>
              Edit Attendance Details
            </Typography>
            <IconButton onClick={handleCloseDrawer}>
              <CloseIcon />
            </IconButton>
          </Box>
          {selectedDate && (
            <Typography variant="body1" sx={{ marginY: 2, fontSize: "20px" }}>
              Date: {selectedDate.toLocaleDateString()}
            </Typography>
          )}
          <hr />
          <Box sx={{ marginTop: "5px", marginBottom: "20px" }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <Button
                variant="contained"
                color="error"
                sx={{ width: "100%", height: "50px", backgroundColor: "#E6292B", fontWeight: "bold" }}
                onClick={() => handleAttendanceChange("Absent")}
                disabled={loadingButton === "Absent"} // Disable button while loading
              >
                {loadingButton === "Absent" ? <CircularProgress size={24} color="inherit" /> : "Absent"}
              </Button>
            </Grid>
            
            <Grid item xs={12} sm={4}>
              <Button
                variant="contained"
                color="success"
                sx={{ width: "100%", height: "50px", backgroundColor: "#5bb659", fontWeight: "bold" }}
                onClick={() => handleAttendanceChange("Present")}
                disabled={loadingButton === "Present"} // Disable button while loading
              >
                {loadingButton === "Present" ? <CircularProgress size={24} color="inherit" /> : "Present"}
              </Button>
            </Grid>
            
            <Grid item xs={12} sm={4}>
              <Button
                variant="contained"
                color="info"
                sx={{ width: "100%", height: "50px", backgroundColor: "#7b81e1", fontWeight: "bold" }}
                onClick={() => handleAttendanceChange("halfDay")}
                disabled={loadingButton === "halfDay"} // Disable button while loading
              >
                {loadingButton === "halfDay" ? <CircularProgress size={24} color="inherit" /> : "halfDay"}
              </Button>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Button
                variant="contained"
                color="success"
                sx={{ width: "100%", height: "50px", backgroundColor: "#5bb659", fontWeight: "bold" }}
                onClick={() => handleAttendanceChange("fullDay")}
                disabled={loadingButton === "fullDay"} // Disable button while loading
              >
                {loadingButton === "fullDay" ? <CircularProgress size={24} color="inherit" /> : "Half Day To Full Day"}
              </Button>
            </Grid>
          </Grid>
        </Box>

          <hr />



       

          {selectedEmployee ? (
  <>
    <strong style={{ fontSize: '20px', paddingLeft: '10px' }}>
      Punch Details - <strong style={{ color: '#7e31ce' }}>{selectedEmployee?.firstName} {selectedEmployee?.lastName}</strong>
    </strong>

    {selectedEmployee.status === "Admin" ? (
     <Typography
     
     style={{
       color: '#fff',
       padding: '20px',
       background: 'linear-gradient(90deg, #7e31ce, #0c8091)',
       borderRadius: '10px',
       textAlign: 'center',
       fontSize:'17px',
       fontWeight: 'bold',
       boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
       textShadow: '1px 1px 2px rgba(0, 0, 0, 0.4)',
       margin: "30px auto",

       width: '50%',
     }}
   >
     Admin Punched
   </Typography>
   
    ) : (
      <>
        <Card sx={{ maxWidth: 900, margin: '10px' }}>
          <strong style={{ fontSize: '15px', padding: '20px', color: '#0c8091' }}>Punch In Details:</strong>
          <CardContent>
            <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
              <Avatar
                alt="Punch In Photo"
                src={selectedEmployee.checkInPic || 'default-placeholder-image-url'}
                sx={{ width: 80, height: 80 }}
              />
              <Box>
                <Typography variant="h6" style={{ fontWeight: 'bold', paddingLeft: '25px', color: '#7e31ce' }}>
                  Punch In Time:
                </Typography>
                {isEditingCheckIn ? (
                  <TextField
                    type="text"
                    value={checkIn}
                    onChange={(e) => setCheckIn(e.target.value)}
                    onBlur={handleCheckInBlur} // Trigger API call when user finishes editing
                    variant="outlined"
                    sx={{ paddingLeft: '25px', paddingTop: 1, width: '150px' }}
                    autoFocus
                  />
                ) : (
                  <Typography
                    variant="h6"
                    style={{ fontWeight: 'bold', paddingLeft: '25px', color: 'Green', paddingTop: 5, cursor: 'pointer' }}
                    onClick={() => setIsEditingCheckIn(true)} // Show input field on click
                  >
                    {selectedEmployee.checkIn || 'N/A'}
                  </Typography>
                )}

                <Typography
                  variant="h6"
                  style={{ fontWeight: 'bold', paddingLeft: '25px', color: '#7e31ce' }}
                  mt={2}
                >
                  Punch In Address:
                </Typography>
                <Typography style={{ paddingLeft: '25px', paddingTop: 5 }}>
                  {selectedEmployee.checkinLocation || 'N/A'}
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
        

        <Divider sx={{ width: '100%', marginY: 2 }} />

        <Card sx={{ maxWidth: 900, boxShadow: 1, margin: '10px' }}>
          <strong style={{ fontSize: '15px', padding: '20px', color: '#0c8091' }}>Punch Out Details:</strong>
          <CardContent>
            <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
              <Avatar
                alt="Punch Out Photo"
                src={selectedEmployee.checkOutPic || 'default-placeholder-image-url'}
                sx={{ width: 80, height: 80 }}
              />
              <Box>
                <Typography variant="h6" style={{ fontWeight: 'bold', paddingLeft: '25px', color: '#7e31ce' }}>
                  Punch Out Time:
                </Typography>
                {isEditingCheckOut ? (
                  <TextField
                    type="text"
                    value={checkOut}
                    onChange={(e) => setCheckOut(e.target.value)}
                    onBlur={handleCheckOutBlur} // Trigger API call when user finishes editing
                    variant="outlined"
                    sx={{ paddingLeft: '25px', paddingTop: 1, width: '150px' }}
                    autoFocus
                  />
                ) : (
                  <Typography
                    variant="h6"
                    style={{ fontWeight: 'bold', paddingLeft: '25px', color: 'Green', paddingTop: 5, cursor: 'pointer' }}
                    onClick={() => setIsEditingCheckOut(true)} // Show input field on click
                  >
                    {selectedEmployee.checkOut || 'N/A'}
                  </Typography>
                )}

                <Typography
                  variant="h6"
                  style={{ fontWeight: 'bold', paddingLeft: '25px', color: '#7e31ce' }}
                  mt={2}
                >
                  Punch Out Address:
                </Typography>
                <Typography style={{ paddingLeft: '25px', paddingTop: 5 }}>
                  {selectedEmployee.checkoutLocation || 'N/A'}
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </>
    )}
  </>
) : (
  <Typography variant="h6" style={{ padding: '20px', textAlign: 'center' }}>
    No Attendance Details Found for the selected date.
  </Typography>
)}












{/* <strong style={{ fontSize: '20px',paddingLeft:'10px' }}>Punch Details - 
      
      <strong style={{ color:'#7e31ce' }}> {selectedEmployee?.firstName} {selectedEmployee?.lastName} </strong>
      </strong>
     
<Card sx={{ maxWidth: 900, margin: '10px' }}>
  <strong style={{ fontSize: '15px', padding: '20px', color: '#0c8091' }}>
    Punch In Details:
  </strong>
  <CardContent>
    <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
      <Avatar
        alt="Punch In Photo"
        src={
          selectedEmployee?.checkInPic
            ? selectedEmployee.checkInPic
            : 'default-placeholder-image-url' // Ensure you have a valid default URL
        }
        sx={{ width: 80, height: 80 }}
      />
      <Box>
        <Typography
          variant="h6"
          style={{ fontWeight: 'bold', paddingLeft: '25px', color: '#7e31ce' }}
        >
          Punch In Time:
        </Typography>
        <Typography
          variant="h6"
          style={{
            fontWeight: 'bold',
            paddingLeft: '25px',
            color: 'Green',
            paddingTop: 5,
          }}
        >
          {selectedEmployee?.checkIn || 'N/A'} 
        </Typography>
        <Typography
          variant="h6"
          style={{ fontWeight: 'bold', paddingLeft: '25px', color: '#7e31ce' }}
          mt={2}
        >
          Punch In Address:
        </Typography>
        <Typography style={{ paddingLeft: '25px', paddingTop: 5 }}>
          {truncateString(selectedEmployee?.checkinLocation, 300) || 'N/A'} 
        </Typography>
      </Box>
    </Box>
  </CardContent>
</Card>


<Divider sx={{ width: '100%', marginY: 2 }} />


<Card sx={{ maxWidth: 900, boxShadow: 1, margin: '10px' }}>
  <strong style={{ fontSize: '15px', padding: '20px', color: '#0c8091' }}>
    Punch Out Details:
  </strong>
  <CardContent>
    <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
      <Avatar
        alt="Punch Out Photo"
        src={
          selectedEmployee?.checkOutPic
            ? selectedEmployee.checkOutPic
            : 'default-placeholder-image-url' // Ensure you have a valid default URL
        }
        sx={{ width: 80, height: 80 }}
      />
      <Box>
        <Typography
          variant="h6"
          style={{ fontWeight: 'bold', paddingLeft: '25px', color: '#7e31ce' }}
        >
          Punch Out Time:
        </Typography>
        <Typography
          variant="h6"
          style={{
            fontWeight: 'bold',
            paddingLeft: '25px',
            color: 'Green',
            paddingTop: 5,
          }}
        >
          {selectedEmployee?.checkOut || 'N/A'} 
        </Typography>
        <Typography
          variant="h6"
          style={{ fontWeight: 'bold', paddingLeft: '25px', color: '#7e31ce' }}
          mt={2}
        >
          Punch Out Address:
        </Typography>
        <Typography style={{ paddingLeft: '25px', paddingTop: 5 }}>
          {truncateStringOUT(selectedEmployee?.checkoutLocation, 300) || 'N/A'}
        </Typography>
      </Box>
    </Box>
  </CardContent>
</Card> */}




        </Box>
      </Drawer>
      <ToastContainer/>
    </Container>
  );
};

export default EmployeeAttendanceDetails;
